import Axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { SerializedError } from "@reduxjs/toolkit";
import "./loading.scss";
import {
  getAccessToken,
  getWorkspaceCode,
  removeAccessToken,
  removeUserInfoFromLocalStorage,
  setRedirectUrl,
} from "./auth";
import { startProgress, stopProgress } from "../../redux/store/progress";
import { stores } from "../../App";
import utilsCommon from "./common";
import utilsClient from "./client";
const axios = Axios.create({
  withCredentials: true,
  headers: {
    locale: "kr-KR",
    "Accept-Language": window.navigator.language.includes("ko")
      ? "ko"
      : ["jp", "ja"].includes(window.navigator.language)
      ? "jp"
      : ["ar"].includes(window.navigator.language)
      ? "ar"
      : "en",
  },
});

let alramCount = 0;
axios.interceptors.request.use(
  function (config: InternalAxiosRequestConfig) {
    !window.eco.isCspp && stores.dispatch(startProgress());

    //(Loading);
    // 요청을 보내기 전에 수행할 일
    // ...
    const token = getAccessToken() as string | "";
    const dsdCode = getWorkspaceCode() as string | "";
    if (token) {
      config.headers.set("X-FASOO-API-TOKEN", token);
      if (window.eco.serviceType === "OCI") {
        config.headers.set("X-FASOO-DSDCODE", dsdCode ?? "MTECOCOMMON00001");
      }
    }
    // console.log("->", config);
    return config;
  },
  function (error) {
    // 오류 요청을 보내기전 수행할 일
    // ...
    return Promise.reject(error);
  }
);

// 응답 인터셉터 추가
axios.interceptors.response.use(
  (response) => {
    !window.eco.isCspp && stores.dispatch(stopProgress());
    if (response.config.url?.includes("eco-gateway/wapi/dashboard/myAlarms")) {
      alramCount++;
    } else {
      alramCount = 0;
    }
    if (alramCount === 72) {
      removeAccessToken();
      removeUserInfoFromLocalStorage();
      window.location.reload();
    }
    return response;
  },
  (error: AxiosError) => {
    !window.eco.isCspp && stores.dispatch(stopProgress());
    const agent = navigator.userAgent.toLowerCase();

    // 오류 응답을 처리
    // ...
    let se: SerializedError;

    if (error.response) {
      const errorData = error.response.data as any;

      if (errorData.errorCode) {
        switch (errorData.errorCode) {
          case "INVALID_SESSION":
            removeAccessToken();
            removeUserInfoFromLocalStorage();
            if (
              !(
                utilsCommon.isClientLogin("MAC") ||
                utilsCommon.isClientLogin("WINDOWS")
              )
            ) {
              if (
                error.response.config.url?.includes(
                  "/eco-gateway/wapi/contents/detail/"
                ) &&
                window.location.href.includes("/action/byuid/")
              ) {
                setRedirectUrl(window.location.href);
                window.location.href = `${process.env.PUBLIC_URL}/linkLogin`;
                return;
              } else window.location.href = `${process.env.PUBLIC_URL}/login`;
            } else {
              utilsClient.goMain();
            }
            return;
          // 저장된 세션 삭제 후 로그인 페이지로 이동
          case "ZOOM_ACCOUNT_NOT_USE_ECO":
            return;
          case "NOT_FOUND_USER":
            return;
          case "NOT_FOUND_DATA":
            break;
          case "BAD_REQUEST":
            break;
          case "INTERNAL_SERVER_ERROR":
          case "INVALID_USER_ID_PWD":
          default:
            // toasts.toastMsg(uuidv4(),errorData.errorMessage, 'error');
            //alert(errorData.errorMessage); //TODO
            break;
        }
      }

      se = {
        name: errorData.errorCode,
        message: errorData.errorMessage,
      };

      return Promise.reject(se);
    }

    se = {
      name: "INTERNAL_SERVER_ERROR",
      message: "INTERNAL_SERVER_ERROR",
    };
    return Promise.reject(se);
  }
);
export default axios;
